import { TextField } from '@material-ui/core';
import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import useForm from 'react-hook-form';
import { RECOVERY_EMAIL, RECOVERY_PASSWORD } from '../../../state/constants/apiConstants';
import * as constants from "../../../state/constants/appConstants";
import Button from '../../atoms/Button/Button';
import ButtonLoading from '../buttonLoading/buttonLoading';
import './forgetSection.scss';
import useLocaleMode from '../../../hooks/useLocaleMode';


const ForgetSection = props => {
  const { forgetType, handleWrongNumber, handlePhoneChars, handleNextButton, handleToggleLoader, handleRegisteredEmail, isWrongNumber, isShowingLoader, isRegisteredEmail, handleIsSended, countryPrefix } = props;
  const refForm = React.useRef();
  const [email] = useState(valueFormLogin());
  const { register, handleSubmit, errors, triggerValidation, formState } = useForm({
  });
  const [values, setValues] = React.useState({
    phone: '',
    email: '',
    phoneErrorMsg: '',
    emailErrorMsg: ''
  });
  const { locale } = useLocaleMode();

  function valueFormLogin() {
    const field = document.querySelector('#form-login-email');

    if (field && field.elements) {
      return field.elements[1].value;
    }
    return email;
  }

  const handleChange = prop => event => {
    triggerValidation({ name: event.target.value });
    if (event.target.name === 'email') {
      setValues({ ...values, [event.target.name]: event.target.value });
      handleRegisteredEmail(false);
    }
  };
  const onSubmitForget = data => {
    if (data.phone) {
      handleToggleLoader(true);
      const payload = {
        cellPhone: `${countryPrefix}${data.phone}`
      };
      axios.post(RECOVERY_EMAIL, payload)
        .then(restData => {
          const { data } = restData;
          if (data.status === 200) {
            handleWrongNumber(false);
            const lastChars = payload.cellPhone.substr(-2);
            handlePhoneChars(lastChars);
            handleNextButton();
          }
          else if (data.status === 400 || data.status === 500) {
            handleWrongNumber(true);
            setValues({ ...values, phoneErrorMsg: data.userMessage })
          }
          handleToggleLoader(false);
        })
        .catch(err => {
          console.log(err); handleToggleLoader(false);
        })
    }
    if (data.email) {
      handleToggleLoader(true);
      axios.get(RECOVERY_PASSWORD + data.email)
        .then(restData => {
          const { data } = restData;
          if (data.status === 200) {
            handleRegisteredEmail(false);
            handleIsSended(true);
          }
          else if (data.status === 400) {
            handleRegisteredEmail(true);
            setValues({ ...values, emailErrorMsg: data.userMessage })
          }
          handleToggleLoader(false);
        }).catch(err => {
          console.log(err); handleToggleLoader(false);
        })
    }
  };
  return (
    <>
      <form id={`form-forget-${forgetType === 0 ? 'email' : 'password'}`} ref={refForm} className="f-forget-login" onSubmit={handleSubmit(onSubmitForget)}>
        {forgetType === 0 ?
          <>
            {locale === "es-AR" ?
              <p className="f-copy-recovery" >Ingresá tu número celular para recuperar tu correo electrónico.</p>
              : <p className="f-copy-recovery" >Ingresa tu número celular para recuperar tu correo electrónico.</p>}
            <TextField
              error={errors.phone != null}
              color="secondary"
              name="phone"
              type="text"
              autoComplete="off"
              className="f-form-input"
              id='f-phone-input'
              onChange={handleChange()}
              label="Número de teléfono"
              variant="outlined"
              helperText={
                errors.phone && errors.phone.type === 'required' ? 'El número de celular es requerido' :
                  errors.phone && errors.phone.type === 'pattern' ? 'Debe ser un número válido' :
                    errors.phone && (errors.phone.type === 'minLength' || errors.phone.type === 'maxLength') ? 'Un número celular requiere 10 cifras.' :
                      (isWrongNumber && formState.isSubmitted) ? values.phoneErrorMsg : ''
              }
              inputRef={register({ required: true, minLength: 10, maxLength: 10, pattern: /^(0|[1-9][0-9]*)$/ })}
            />
            {/* <ButtonLoading isEnabled={(formState.touched.length === 0) || (!formState.isValid && formState.touched.length === 1)} */}
            <ButtonLoading isEnabled={false}
              button={
                <Button id='f-email-recovery-btn' type="input" classname="f-button f-button--primary" text="Recuperar" />
              }
              isShowingLoader={isShowingLoader}
              bgClass="primary" />

          </>
          :
          <>
            <p className="f-copy-recovery">Ingresa tu correo electrónico y te enviaremos una contraseña temporal para que inicies sesión.</p>
            <TextField
              error={errors.email != null || (isRegisteredEmail && formState.isSubmitted)}
              color="secondary"
              name="email"
              defaultValue={email}
              type="text"
              autoComplete="off"
              className="f-form-input"
              id='f-email-input'
              onChange={handleChange()}
              label="¿Cuál es tu correo electrónico?"
              variant="outlined"
              helperText={
                errors.email && errors.email.type === 'required' ? 'Tu correo electrónico es requerido' :
                  errors.email && errors.email.type === 'pattern' ? 'El correo electrónico ingresado no es válido' :
                    (isRegisteredEmail && formState.isSubmitted) ? values.emailErrorMsg : ''
              }
              inputRef={register({ required: true, pattern: constants.EMAIL_PATTERN })}
            />
            {/* <ButtonLoading isEnabled={(formState.touched.length === 0 && email === null) || (!formState.isValid && formState.touched.length === 1)} */}
            <ButtonLoading isEnabled={false}
              button={
                <Button id='f-password-recovery-btn' type="input" classname="f-button f-button--primary" text="Siguiente" />
              }
              isShowingLoader={isShowingLoader}
              bgClass="primary" />
          </>
        }
      </form>
    </>
  )
};

ForgetSection.propTypes = {
  forgetType: PropTypes.number.isRequired,
  handleWrongNumber: PropTypes.func,
  handleNextButton: PropTypes.func,
  handlePhoneChars: PropTypes.func,
  handleToggleLoader: PropTypes.func,
  handleRegisteredEmail: PropTypes.func,
  isWrongNumber: PropTypes.bool,
  isShowingLoader: PropTypes.bool,
  isRegisteredEmail: PropTypes.bool,
  handleIsSended: PropTypes.func
};

export default ForgetSection;